/* src/app/shared/popups/popup-duplicate-order/popup-duplicate-order.component.scss */
:host h2 {
  margin-top: 0;
}
.cw-horizontalline {
  border-color: var(--color-accent);
  height: 2px;
}
.cw-dialog-content {
  line-height: 20px;
  max-height: 400px;
  overflow: auto;
}
.duplicate-order-table {
  width: 100%;
  border-collapse: collapse;
  margin: 12px 0;
}
.duplicate-order-table th,
.duplicate-order-table td {
  text-align: left;
  padding: 6px 12px 6px 0;
}
.duplicate-order-table thead tr {
  border-bottom: 2px solid var(--color-accent, #ccc);
}
.duplicate-order-table tbody tr {
  border-bottom: 1px solid #eee;
}
.duplicate-order-table tbody tr:last-child {
  border-bottom: none;
}
/*# sourceMappingURL=popup-duplicate-order.component.css.map */
